import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  FormControl,
  FormHelperText,
  TextField,
  IconButton,
  Typography,
} from '@material-ui/core';
import {Add as AddIcon, Remove as RemoveIcon} from '@material-ui/icons';
import {isEmpty} from 'lodash/lang';
import {formShape} from 'rc-form';

export default class CounterField extends React.Component {
  static propTypes = {
    form: formShape.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    rules: PropTypes.array.isRequired,
    initialValue: PropTypes.string.isRequired,
    helpText: PropTypes.string.isRequired,
  };
  static defaultProps = {
    rules: [],
    initialValue: 0,
    helpText: '',
  };

  handleDecrease = () => {
    const {form, name} = this.props;
    const currentValue = form.getFieldValue(name) || 0;
    form.setFieldsValue({[name]: currentValue - 1});
  };

  handleIncrease = () => {
    const {form, name} = this.props;
    const currentValue = form.getFieldValue(name) || 0;
    form.setFieldsValue({[name]: currentValue + 1});
  };

  render() {
    const {
      name,
      label,
      rules,
      initialValue,
      helpText,
      form: {getFieldDecorator, getFieldError},
      ...restProps
    } = this.props;

    const errors = getFieldError(name);
    const hasError = !isEmpty(errors);
    const error = hasError ? errors[0] : '';

    return (
      <FormGroup className="mui-form-group">
        <FormControl error={hasError}>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{margin: '4px 0'}}>
              <Typography style={{fontSize: 12}} color="textSecondary">
                {label}
              </Typography>
            </div>
            <div style={{margin: '4px 0'}}>
              <IconButton onClick={this.handleDecrease} color="primary" size="small">
                <RemoveIcon />
              </IconButton>
              {getFieldDecorator(name, {
                rules,
                initialValue,
              })(
                <TextField
                  id={name}
                  name={name}
                  type="number"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    style: {textAlign: 'center'},
                    inputMode: 'none',
                    readOnly: true,
                  }}
                  {...restProps}
                  style={{margin: '0 8px'}}
                />,
              )}
              <IconButton onClick={this.handleIncrease} color="primary" size="small">
                <AddIcon />
              </IconButton>
            </div>
          </div>
          {helpText && <FormHelperText error={false}>{helpText}</FormHelperText>}
          {hasError && <FormHelperText error>{error}</FormHelperText>}
        </FormControl>
      </FormGroup>
    );
  }
}
